import { REACT_APP_HOST_URL, REACT_APP_API_URL } from '../env'

const base = {
  version: '1.1.5',
  adminUrl: REACT_APP_HOST_URL,
  apiUrl: `${REACT_APP_API_URL}/api`,
  env: process.env.REACT_APP_ENV,
  pusher_key: process.env.REACT_APP_PUSHER_KEY,
  googleAnalytics: process.env.REACT_APP_GOOGLE_ANALYTICS
}

export const config = {
  ...base
}
